<template>
    <div class="main">   
        <div class="list-turma">

            <c-panel>

                <el-form label-position="top" class="u-mb-30">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="15" :md="17" v-if="($store.state.user.tipo > 3 && $store.state.user.tipo <= 8) || $store.state.user.tipo == 10">
                            <el-form-item key="instituicao">
                                <el-select @change="changeFiltros" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="$store.state.user.tipo == 6" :xs="24" :sm="9" :md="7" class="u-text-right">
                            <el-button type="primary" @click="showDialogFormCategoria()">NOVA CATEGORIA</el-button>
                        </el-col>
                    </el-row>
                </el-form>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th class="hidden-mobile" style="width: 70px;">cod</th>
                                <th>Nome</th>
                                <th class="hidden-mobile u-text-center">Visível</th>
                                <th style="width: 150px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody v-if="statusList">
                            <tr v-for="item in items" :key="item.id">
                                <td class="hidden-mobile">{{ item.id }}</td>
                                <td>{{ item.name }}</td>
                                <td class="hidden-mobile u-text-center">{{ (item.visible) ? 'Sim' : 'Não' }}</td>
                                <td class="u-text-center acao"> 
                                    <el-button @click="deleteCategoria(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="!statusList" class="u-text-center u-mt-25">
                        <img src="/public/img/loading-bar.gif" />
                    </div>
                </div>

                <div v-if="!statusList" class="u-text-center" style="margin-top: 50px; margin-bottom: 50px;">
                    <hr>
                        <img class="u-mt-10 u-mb-10" src="/public/img/loading-bar.gif" />
                    <hr>
                </div>

                <div v-if="statusList && filtro.instituicao.id && Object.keys(items).length === 0">
                    <h4 class="u-text-center">nenhuma categoria cadastrada</h4>
                </div>

                <div v-if="statusList && !filtro.instituicao.id && Object.keys(items).length === 0">
                    <h4 class="u-text-center">selecione uma instituição</h4>
                </div>

            </c-panel>        

            <el-dialog :close-on-click-modal="false" title="NOVA CATEGORIA" width="70%" top="5vh" :visible.sync="dialogFormCategoria">
                <div class="main">
                    <el-form @submit.native.prevent="onSubmitCategoria" :model="form" ref="form" label-position="top">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Código" prop="cod" :rules="[$requiredBlur]" key="cod">
                                    <el-input v-model="form.cod" maxlength="191" v-on:blur="formatData('cod')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="18" :md="18">
                                <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
                                    <el-input v-model="form.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :xs="24">
                                <el-form-item class="u-text-right u-mt-15">
                                    <el-button type="primary" id="btn-modelo" native-type="submit">SALVAR</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </el-dialog>

        </div>
    </div>
</template>
<script>

export default {
    data: () => ({
        dialogFormCategoria: false,
        statusList: true,
        filtro: {
            instituicao: {
                id: '',
                nome: ''
            }
        },
        items: {},
        selectInstituicoes: [],
        form: {
            cod: '',
            nome: ''
        }

    }),
    mounted(){

        if(this.$store.state.config.instituicao){

            this.filtro.instituicao = this.$store.state.config.instituicao;
        }

        this.loadingCategorias();
    },
    methods: {
        
        loadingCategorias(){

            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id){

                return false;
            }

            let i = this.$store.state.config.instituicao.id;

            this.statusList = false;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ava/categorias?instituicao_id=${i}`, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        async changeFiltros(){

            if(this.$store.state.user.tipo > 3 && this.$store.state.user.tipo <= 8){

                await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id);
            }

            this.loadingCategorias();
        },
        deleteCategoria(id){

            this.$msgbox.confirm('Tem certeza que deseja excluir esta categoria?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/ava/categoria/${id}`, this.$store.getters.getHeaderAuth).then(response => {
                            
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingCategorias();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        showDialogFormCategoria(){

            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id){

                window.eventBus.$emit('alert', {msg: 'Por favor, selecione uma instituição.', type: 'warning'});
                return false;
            }

            this.form = {
                cod: '',
                nome: ''
            };

            this.dialogFormCategoria = true

        },
        onSubmitCategoria(){

            this.$refs.form.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true);                

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ava/categoria`, { instituicao_id: null, parente: this.filtro.instituicao.id, ...this.form }, this.$store.getters.getHeaderAuth).then(response => {
                
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                    this.dialogFormCategoria = false
                    this.loadingCategorias();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.form[field])
                return false;

            if(size && this.form[field].length < size)
                this.form[field] = '';            

            this.form[field] = this.form[field].toUpperCase();
        }
    },
    components:{  }
}
</script>